import { FC } from 'react'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { PublishQuoteModalProps } from './types'
import { ModalWithEsignatures } from './ModalWithEsignatures'
import { ModalWithoutEsignatures } from './ModalWithoutEsignatures'

export const PublishQuoteModal: FC<PublishQuoteModalProps> = props => {
  const ctx = useCubeContext()

  const isSignaturesEnabled = ctx.queries.rawData.data.quote.isSignaturesEnabled

  return isSignaturesEnabled ? (
    <ModalWithEsignatures {...props} />
  ) : (
    <ModalWithoutEsignatures {...props} />
  )
}
